<template>
  <section id="about" class="section-padding relative overflow-hidden transition-colors duration-500"
    :class="isDark ? 'galaxy-section-alt-dark' : 'galaxy-section-alt-light'"
  >
    <!-- Subtle nebula background -->
    <div class="absolute inset-0 pointer-events-none overflow-hidden">
      <div class="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-10"
        :class="isDark ? 'bg-nebula-purple' : 'bg-primary-300'"
      ></div>
      <div class="absolute bottom-0 left-0 w-80 h-80 rounded-full blur-3xl opacity-10"
        :class="isDark ? 'bg-nebula-cyan' : 'bg-accent-200'"
      ></div>
    </div>

    <div class="max-w-5xl mx-auto text-center relative z-10">
      <h2 class="text-3xl md:text-4xl font-bold mb-8">
        <span class="galaxy-text-gradient">{{ t('about.sectionTitle') }}</span>
      </h2>
      <p class="text-lg leading-relaxed mb-12 max-w-3xl mx-auto"
        :class="isDark ? 'text-galaxy-200' : 'text-gray-600'"
      >
        {{ t('about.description') }}
      </p>

      <div class="galaxy-card p-8 md:p-12 max-w-2xl mx-auto relative"
        :class="isDark ? 'border-t-4 border-nebula-pink' : 'border-t-4 border-secondary'"
      >
        <h3 class="text-2xl font-bold mb-4"
          :class="isDark ? 'text-nebula-pink' : 'text-secondary'"
        >
          {{ t('about.mission') }}
        </h3>
        <p class="text-lg leading-relaxed"
          :class="isDark ? 'text-galaxy-200' : 'text-gray-600'"
        >
          {{ t('about.missionText') }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

defineProps<{ isDark: boolean }>()

const { t } = useI18n()
</script>
